import React from 'react';
import { useResume } from '../context/ResumeContext';
import { useWorkspaceContext } from '../../../pages/ChatPage/providers/WorkspaceProvider';
import AIAssistField from '../components/AIAssistField';

export default function SummarySection() {
  const { activeResume, updateField, validationResults } = useResume();
  const { authToken, theme } = useWorkspaceContext();
  const summaryVal = validationResults['summary'] || {};

  const labelStyle = {
    fontFamily: "'Outfit', sans-serif",
    fontSize: '11px',
    fontWeight: 700,
    letterSpacing: '0.5px',
    textTransform: 'uppercase',
    color: 'var(--text-secondary)',
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', padding: '8px 0' }}>
      <label style={labelStyle}>Professional Summary</label>
      <AIAssistField
        type="textarea"
        value={activeResume?.summary || ''}
        onChange={(val) => updateField('summary', val)}
        placeholder="Briefly describe your career goals, key expertise, and major achievements..."
        rows={6}
        authToken={authToken}
        theme={theme}
      />
      
      {summaryVal.errors?.map((err, idx) => (
        <span key={idx} style={{ fontSize: '10px', color: 'var(--status-danger)', marginTop: '2px' }}>{err}</span>
      ))}
      {summaryVal.warnings?.map((warn, idx) => (
        <span key={idx} style={{ fontSize: '10px', color: 'var(--status-warning)', marginTop: '2px' }}>{warn}</span>
      ))}
    </div>
  );
}
